/* eslint-disable*/
import React, { useState } from 'react';
import { Button, Space, Row, Col } from 'antd';

import 'antd/dist/antd.css';

const LagescoresOptionsLayer = ({ handleOnClick }) => {
  const [size, setSize] = useState(20);
  const [active, setActive] = useState('Wohnlage');

  const handleChange = (data) => {
    setActive(data);
    handleOnClick(data);
  };
  return (
    <div
      style={{
        paddingBottom: '20px',
      }}
    >
      <Space size={size}>
        {active === 'Wohnlage' ? (
          <Button
            className="button1"
            shape="round"
            size="large"
            style={{
              background: '#000000',
              color: '#ffffff',
              borderColor: '#000000',
            }}
            onClick={() => handleChange('Wohnlage')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/akar-icons_location-white.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '8px',
                }}
              >
                Wohnlage
              </div>
            </div>
          </Button>
        ) : (
          <Button
            shape="round"
            size="large"
            onClick={() => handleChange('Wohnlage')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/akar-icons_location.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '4px',
                }}
              >
                Wohnlage
              </div>
            </div>
          </Button>
        )}

        {active === 'ÖPNV' ? (
          <Button
            shape="round"
            size="large"
            style={{
              background: '#000000',
              color: '#ffffff',
              borderColor: '#000000',
            }}
            onClick={() => handleChange('ÖPNV')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/bx_bx-train-white.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '8px',
                }}
              >
                ÖPNV
              </div>
            </div>
          </Button>
        ) : (
          <Button
            shape="round"
            size="large"
            onClick={() => handleChange('ÖPNV')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/bx_bx-train.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '4px',
                }}
              >
                ÖPNV
              </div>
            </div>
          </Button>
        )}

        {active === 'Kultur' ? (
          <Button
            shape="round"
            size="large"
            style={{
              background: '#000000',
              color: '#ffffff',
              borderColor: '#000000',
            }}
            onClick={() => handleChange('Kultur')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/bx_bxs-music-white.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '8px',
                }}
              >
                Kultur
              </div>
            </div>
          </Button>
        ) : (
          <Button
            shape="round"
            size="large"
            onClick={() => handleChange('Kultur')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/bx_bxs-music.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '4px',
                }}
              >
                Kultur
              </div>
            </div>
          </Button>
        )}

        {/* {active === 'Internet' ? (
          <Button
            shape='round'
            size='large'
            style={{ background: '#000000', color: '#ffffff', borderColor: "#000000", }}
            onClick={() => handleChange('Internet')}>
            <img
              src={`/assets/img/lagescoresOptions/akar-icons_wifi-white.svg`}
              alt=''
            />
            Internet
          </Button>
        ) : (
          <Button
            shape='round'
            size='large'
            onClick={() => handleChange('Internet')}>
            <img
              src={`/assets/img/lagescoresOptions/akar-icons_wifi.svg`}
              alt=''
            />
            Internet
          </Button>
        )} */}

        {active === 'Nahversorgung' ? (
          <Button
            shape="round"
            size="large"
            style={{
              background: '#000000',
              color: '#ffffff',
              borderColor: '#000000',
            }}
            onClick={() => handleChange('Nahversorgung')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/ant-design_shop-outlined-white.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '8px',
                }}
              >
                Nahversorgung
              </div>
            </div>
          </Button>
        ) : (
          <Button
            // className="button1 ant-btn ant-btn-round ant-btn-default ant-btn-lg"
            shape="round"
            size="large"
            // type="primary"
            onClick={() => handleChange('Nahversorgung')}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div>
                <img
                  src={`/assets/img/lagescoresOptions/ant-design_shop-outlined.svg`}
                  alt=""
                />
              </div>
              <div
                style={{
                  marginTop: '2px',
                  marginLeft: '4px',
                }}
              >
                Nahversorgung
              </div>
            </div>
          </Button>
        )}
      </Space>
    </div>
  );
};

export default LagescoresOptionsLayer;
